<template>
  <div class="w-full relative">
    <textarea ref="input" v-bind="$attrs" :disabled="disabled" :placeholder="placeholder" :value="value" :readonly="readonly"
      :class="wrapperClass"
      @input="onInput" @keyup="keyup" @keydown="keydown" @focus="onFocus"></textarea>
      <span class="absolute text-danger text-sm bottom-0 left-0" v-if="hasErrors">
        {{ firstErrorMessage }}
      </span>
  </div>
</template>

<script>
import { twMerge } from 'tailwind-merge';
import { singleErrorExtractorMixin } from 'vuelidate-error-extractor';

export default {
  name: 'TextArea',
  mixins: [singleErrorExtractorMixin],
  inheritAttrs: false,
  props: {
    value: {},
    variant: { type: String, default: 'base' },
    placeholder: { type: String, default: '' },
    readonly: {
      type: Boolean,
      default: false,
    },
    noresize: { type: Boolean, default: true },
    selectAll: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    wrapperClass() {
      const baseClass = 'w-full h-full outline-none px-4 py-2 border rounded-lg';
      const variantClass = {
        base: 'bg-white text-dark border-grey-200',
        dark: 'bg-secondary text-secondary-invert border-secondary-lighter'
      };
      const resizeClass = this.noresize ? 'resize-none' : 'resize-y';
      const errorClass = this.hasErrors ? 'border-danger mb-3 ' : '';
      const disabledClass = this.disabled ? 'cursor-not-allowed opacity-50' : '';
      return twMerge(baseClass, variantClass[this.variant], resizeClass, errorClass, disabledClass);
    }
  },
  methods: {
    onInput() {
      this.$emit('input', this.$refs.input.value);
    },
    keyup() {
      this.$emit('input', this.$refs.input.value);
      this.$emit('keyup', this.$refs.input.value);
    },
    keydown(e) {
      this.$emit('keydown', e);
    },
    onFocus(e) {
      if (this.selectAll) {
        e.target.select();
      }
    },
  },
};
</script>
